import caixaEntrada from '@/App/(authenticated)/modulos/analise/vistoria/caixa-entrada/caixa-entrada.vue'
import caixaFinalizadas from '@/App/(authenticated)/modulos/analise/vistoria/caixa-finalizadas/caixa-finalizadas.vue'

export const items = [
  {
    path: 'caixa-entrada',
    name: 'vistoria/caixa-entrada',
    component: caixaEntrada,
    meta: {
      routeGroup: 'vistoria/caixa-entrada'
    }
  },
  {
    path: 'caixa-finalizadas',
    name: 'vistoria/caixa-finalizadas',
    component: caixaFinalizadas,
    meta: {
      routeGroup: 'vistoria/caixa-finalizadas'
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/vistoria/routes.js